import { translate } from 'App/Internationalization';
import BaseInput from 'shared/Forms/Inputs/BaseInput';
import React from 'react';

export default class InputStreetAddress extends React.Component {
	render() {
		const placeholder = translate(
			'global.forms.inputs.address.street_address_1.placeholder'
		);

		return (
			<BaseInput
				autocomplete="address-line1"
				className={this.props.className}
				disabled={this.props.disabled}
				name={this.props.name}
				placeholder={placeholder}
				required={this.props.required}
				type="text"
			/>
		);
	}
}

InputStreetAddress.defaultProps = {
	className: '',
	disabled: false,
	name: 'streetAddress1',
	required: false,
};
